import { HTMLProps, useState } from "react";

interface Props extends HTMLProps<HTMLDivElement> {
  url: string;
}

function Avatar(props: Props) {
  const { url, ...htmlProps } = props;

  const [avatar, setAvatar] = useState<string>(url || "https://static.portant.co/default-user.png");

  function handleImageOnError() {
    setAvatar("https://static.portant.co/default-user.png");
  }

  return (
    <div {...htmlProps}>
      <img className="h-full w-full rounded-full border-2 border-white drop-shadow" src={avatar} alt={"User Avatar"} onError={handleImageOnError} />
    </div>
  );
}

export default Avatar;
